import React, { useMemo, useState, useCallback } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNotifications } from "../../../APIContext/NotificationContext";
import "./newNotify.css";

const Notifications = () => {
  const { notifications, unreadCount, markAsRead, fetchNotifications } =
    useNotifications();
  const [dialogVisible, setDialogVisible] = useState(false);
  const [selected, setSelected] = useState(null);

  const sortedNotifications = useMemo(() => {
    if (!Array.isArray(notifications)) return [];
    return [...notifications].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at),
    );
  }, [notifications]);

  const openDetails = useCallback(
    async (n) => {
      setSelected(n);
      setDialogVisible(true);
      if (!n.is_read) {
        try {
          await markAsRead(n.id);
        } catch (_) {}
      }
    },
    [markAsRead],
  );

  const refresh = useCallback(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  return (
    <div className="notifications-page">
      <div className="notifications-header">
        {/* <h2>Notifications</h2> */}
        <div className="notifications-actions">
          <span className="unread-badge">Unread: {unreadCount}</span>
          <Button
            label="Refresh"
            onClick={refresh}
            className="p-button-sm p-button-primary"
          />
        </div>
      </div>

      <div className="notifications-list">
        {sortedNotifications.length === 0 ? (
          <div className="empty-state">No notifications yet.</div>
        ) : (
          <ul className="notifications-ul">
            {sortedNotifications.map((n) => (
              <li
                key={n.id}
                className={`notification-item ${n.is_read ? "read" : "unread"}`}
                onClick={() => openDetails(n)}
              >
                <div className="notification-header">
                  <div className="notification-title black-text-clip">
                    {n.notification?.title || n.title || "Notification"}
                  </div>
                  {!n.is_read && (
                    <span className="new-badge">
                      <span className="black-text-clip">New</span>
                    </span>
                  )}
                </div>
                <div className="notification-message black-text-clip">
                  {n.notification?.message || n.message || ""}
                </div>
                <div className="notification-date">
                  {new Date(n.created_at).toLocaleString()}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>

      <Dialog
        header={
          selected?.notification?.title || selected?.title || "Notification"
        }
        visible={dialogVisible}
        className="notification-dialog"
        modal
        onHide={() => setDialogVisible(false)}
      >
        <div className="dialog-message">
          {selected?.notification?.message || selected?.message || ""}
        </div>
        {selected?.extra && (
          <div className="dialog-extra">
            <pre>{JSON.stringify(selected.extra, null, 2)}</pre>
          </div>
        )}
      </Dialog>
    </div>
  );
};

export default Notifications;
